module.exports = __webpack_public_path__ + "static/img/Cover-AZ-F.e145ca57.jpg";